import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "rows", "row", "button"]

  buttonTargetConnected(button) {
    button.hidden = false
  }

  rowTargetConnected(row) {
    this.syncUnset(row)
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      Date.now(),
    )
    this.rowsTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    const row = event.target.closest("[data-config-pairs-target~=row]")
    if (this.rowTargets.length === 1) {
      this.add()
    }
    row.remove()
  }

  toggleUnset(event) {
    this.syncUnset(event.target.closest("[data-config-pairs-target~=row]"))
  }

  syncUnset(row) {
    const unset = row.querySelector("input[type=checkbox]")
    const value = row.querySelector("[data-config-pairs-target~=value]")
    if (unset && value) {
      value.disabled = unset.checked
    }
  }
}
